export function isEmpty(value) {
  return value === null || value === undefined || value === ''
}
export function isObject(value) {
  return value && typeof value === 'object'
}



// WEBPACK FOOTER //
// ./src/modules/shared/utils/type.js